module.exports = __webpack_public_path__ + "static/img/bg-tr.0562228b.png";